import * as React from 'react'
import { connect } from 'react-redux'
import { Text, StackChildren } from '@doordash/design-language'
import * as events from '../../../events'

import t from './strings'

type ApplicationClosedType = {
  submarket?: string
  trackApplicationClosed?: (string) => Promise<any>
}

export class ApplicationClosed extends React.Component<ApplicationClosedType> {
  public static defaultProps: ApplicationClosedType = {
    submarket: 'san francisco',
    trackApplicationClosed: () => Promise.resolve(console.log),
  }

  public componentDidMount() {
    const { submarket, trackApplicationClosed } = this.props
    trackApplicationClosed(submarket)
  }

  public render() {
    return (
      <StackChildren>
        <Text
          styles={Text.Styles.Bold32}
          tag="h1"
          color={Text.Colors.TextAction}
        >
          {t.h1()}
        </Text>
        <Text styles={Text.Styles.PageDescriptionBody}>{t.body()}</Text>
      </StackChildren>
    )
  }
}

const mapStateToProps = state => ({
  submarket: state.application.submarket,
})

const mapDispatchToProps = {
  trackApplicationClosed: events.trackApplicationClosed,
}

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationClosed)
